
import { Trophy, GraduationCap, Users } from "lucide-react";

const programs = [
  {
    icon: Trophy,
    title: "Professional Preparation",
    description: "Prepare & promote aspiring players for professional basketball opportunities stateside and abroad.",
  },
  {
    icon: GraduationCap,
    title: "College Scholarship Path",
    description: "Prepare and promote high school players for college basketball scholarship opportunities.",
  },
  {
    icon: Users,
    title: "Youth Development",
    description: "Fundamental basketball training and player development services for ages 10 & up.",
  },
];

const Programs = () => {
  return (
    <section className="py-8 sm:py-12 md:py-16 bg-accent" id="programs">
      <div className="container mx-auto px-4 sm:px-6">
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-primary mb-8 sm:mb-12">
          Our Training Programs
        </h2>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
          {programs.map((program, index) => (
            <div
              key={index}
              className="bg-white p-4 sm:p-6 md:p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 animate-fade-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <program.icon className="h-8 w-8 sm:h-10 sm:w-10 md:h-12 md:w-12 text-secondary mb-4 sm:mb-6 mx-auto" />
              <h3 className="text-lg sm:text-xl font-semibold text-primary mb-3 sm:mb-4 text-center">{program.title}</h3>
              <p className="text-sm sm:text-base text-gray-600">{program.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Programs;
